/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
/**
 * @author eric.wittmann@gmail.com
 * @enum
 * @property {TraverserDirection} down
 * @property {TraverserDirection} up
 * @class
 */
export enum TraverserDirection {
    down, up
}


